export enum BusinessTripRatesRestoreOption {
  Allowance = 0,
  Accomodation = 1,
  HotelLimit = 2,
}
